<template>
    <div class="swiperCon">
        <van-swipe :autoplay="3000" :indicator-color="!$newYearStyle ? '#1989fa' : '#E14823'">
            <van-swipe-item v-for="(image, index) in data" :key="index">
                <div @click="link(image)" style="display: inline-block">
                    <van-image :src="image[srcProp]" />
                </div>
            </van-swipe-item>
        </van-swipe>
    </div>
</template>

<script>
import client from '@/configs/client.js'

export default {
    name: "MySwiper",
    props: {
        data: {
            type: Array,
            default: () => {
                return [];
            },
        },
        srcProp: {
            type: String,
            default: "url",
        },
    },
    methods: {
        link(item) {
            if (client.xinhua) {
                if (item.uuid || item.url) {
                    let data = item.uuid ? {
                        jumpType: 2,
                        jumpUrl: '',
                        isLink: false,
                        uuid: item.uuid,
                        type: item.type == 1 ? 1 : 2,
                        starUuid: '',
                        jumpToComment: 0,
                        jumpToAIPlay: 0,
                        viewType: 0
                    } : {
                        jumpType: 1,
                        jumpUrl: item.url,
                        isLink: true,
                        uuid: '',
                        type: 1,
                        starUuid: '',
                        jumpToComment: 0,
                        jumpToAIPlay: 0,
                        viewType: 0
                    };
                    /* eslint-disable */
                    if (client.ios) {
                        window.webkit.messageHandlers.goAppDetail.postMessage(data);
                    } else {
                        xinhuanet.goAppDetail(JSON.stringify(data));
                    }
                    /* eslint-enable */
                }
            } else if (item.url) {
                location.href = item.url;
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.van-swipe {
    height: 200px;
    border-radius: 24px;
    overflow: hidden;
}
.van-swipe-item {
    & > div {
        width: 100%;
    }
    .van-image {
        width: 100%;
        height: 200px;
        background: #fff;
    }
}
.van-swipe__indicator {
    width: 20px;
    height: 2px;
    background: #fff;
    border-radius: 0;
}
</style>